import { render, staticRenderFns } from "./barra-ventas-observaciones.vue?vue&type=template&id=23523028&scoped=true&"
import script from "./barra-ventas-observaciones.vue?vue&type=script&lang=ts&"
export * from "./barra-ventas-observaciones.vue?vue&type=script&lang=ts&"
import style0 from "./barra-ventas-observaciones.vue?vue&type=style&index=0&id=23523028&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23523028",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VProgressCircular,VRow,VSpacer,VTextField})
